module.exports = __webpack_public_path__ + "img/4-5.0498317c.svg";